module.exports = __webpack_public_path__ + "img/w17-cover.3203548d.jpg";